define('edap-demo-integration',['edap'], function(edap) {
    'use strict';

    var moduleName = 'demo',
        myEdap = new edap.Scope(moduleName);

    myEdap.on('whos.there', function() {
        console.log(moduleName + ' is ready and listening');
    });

    return edap;
});

